import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { BookResponse } from './getBook';

type GetBooksProps = {
  artistId: string;
  lastItemIdentifier?: string;
  searchTitleTerm?: string;
  limit?: number;
};

/* eslint-disable camelcase */
type QueryParams = {
  limit: number;
  last_item_identifier?: string;
  search_title_term?: string;
};
/* eslint-enable camelcase */

export const getBooks = async ({ artistId, lastItemIdentifier, searchTitleTerm, limit = 10 }: GetBooksProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/books`;

  const queryParams: QueryParams = {
    limit,
    last_item_identifier: lastItemIdentifier,
  };

  if (searchTitleTerm) {
    queryParams.search_title_term = searchTitleTerm;
  }

  const response = await api.executeGetRequest<PaginatedListResponse<BookResponse>>(url, queryParams);

  return response.data;
};
